<div class="content d-flex flex-row align-items-center justify-content-between w-100">
  <h1 [style.color]="row().labelColour">{{ row().title }}</h1>
  <div class="flex-spacer"></div>
  @if (row().showDate) {
    <mat-form-field appearance="fill" color="primary" class="compact">
      <mat-label>Report Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="value" (ngModelChange)="onValueChanges($event)" />
      <mat-datepicker #picker></mat-datepicker>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    </mat-form-field>
  }
  @if (template().procedureId !== 0) {
    <div class="flex-spacer"></div>
    <mat-form-field appearance="fill" color="primary">
      <mat-label>Selected Procedure Entry</mat-label>
      <mat-select [(ngModel)]="template().procedureEntryId" (ngModelChange)="onProcedureEntryChange()">
        @for (entry of entryOptions(); track entry) {
          <mat-option [value]="entry.value">
            {{ entry.text }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
